import React from 'react'
import PropTypes from 'prop-types'
import { FlexGrid, StackView } from '@telus-uds/components-web'
import styled from 'styled-components'

const CustomIndent = styled.div`
  @media (max-width: 992px) {
    margin-left: 24px;
  }
  @media (min-width: 993px) {
    margin-left: 32px;
  }
`

const WithIndent = ({ children }) => (
  <CustomIndent>
    <FlexGrid gutter={false}>
      <FlexGrid.Row>
        <FlexGrid.Col>
          <StackView space={2} direction="column">
            {children}
          </StackView>
        </FlexGrid.Col>
      </FlexGrid.Row>
    </FlexGrid>
  </CustomIndent>
)

WithIndent.propTypes = {
  children: PropTypes.node.isRequired
}

export default WithIndent
